/*
 * /traits (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Divider, Page, PageHeader } from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { TraitAiSuggestions } from "../../features/traits/components/trait-ai-suggestions"
import { UserTraitsList } from "../../features/traits/components/user-traits-list"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/traits/")({
	component: TraitsPage,
	loader: authPageLoader,
})

function TraitsPage() {
	const { user } = Route.useLoaderData()

	const {
		data: userTraits,
		isLoading: userTraitsLoading,
		refetch: refetchUserTraits,
	} = trpc.userTrait.getAllByFilter.useQuery({
		where: { userId: user.id },
		sort: { column: "createdAt", direction: "desc" },
	})

	const { data: allTraits, refetch: refetchTraits } =
		trpc.trait.getAllByFilter.useQuery({})

	async function handleChanged() {
		await Promise.all([refetchUserTraits(), refetchTraits()])
	}

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Traits"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<UserTraitsList
					userTraits={userTraits || []}
					traits={allTraits || []}
					isLoading={userTraitsLoading}
					onChanged={handleChanged}
				/>
				<Divider />
				<TraitAiSuggestions onApplied={handleChanged} />
			</Container>
		</Page>
	)
}
